import React, { useEffect, useState } from "react";
import { Table, Container, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import { getTickets, updateTicket } from "../../../Service/AllTicketServiceAPI";

const OmcApproved = () => {
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewImageBase64, setPreviewImageBase64] = useState(null);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [searchTicketNo, setSearchTicketNo] = useState("");

  const rowsPerPage = 4;

  useEffect(() => {
    fetchTickets();
  }, []);



  const fetchTickets = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const userId = sessionStorage.getItem("pkUserId");

      const response = await getTickets({
        omcApprovalStatus: "APPROVED",
        userId,
        role,
      });

      const data = response.data;

      const sortedData = (data || []).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      const editableData = sortedData.map((ticket) => ({
        ...ticket,
        isEditing: false,
        imageFile: null,
      }));

      setTickets(editableData);
    } catch (error) {
      console.error("Error fetching NON-SLA OPEN tickets:", error);
    }
  };


      const renderTableTooltip = (text, maxLength = 25) => {
  if (!text) return "-";

  return (
    <div className="table-tooltip">
      <span>
        {text.length > maxLength ? text.substring(0, maxLength) + "..." : text}
      </span>

      {text.length > maxLength && (
        <span className="table-tooltip-text">{text}</span>
      )}
    </div>
  );
};


  const handleEditToggle = (ticketNumber) => {
    const updated = tickets.map((ticket) =>
      ticket.ticketNumber === ticketNumber
        ? { ...ticket, isEditing: !ticket.isEditing }
        : ticket
    );
    setTickets(updated);
  };

  const handleInputChange = (ticketNumber, field, value) => {
    const updated = tickets.map((ticket) =>
      ticket.ticketNumber === ticketNumber ? { ...ticket, [field]: value } : ticket
    );
    setTickets(updated);
  };

  const handleFileChange = (ticketNumber, file) => {
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 100 * 1024;

    if (!validTypes.includes(file.type)) {
      swal("Invalid Format", "Only JPG, JPEG, and PNG files are allowed.", "warning");
      return;
    }

    if (file.size > maxSize) {
      swal(
        "File Too Large",
        "Image must be less than 100 KB. Use an online compressor like https://image.pi7.org/reduce-image-size-in-kb.",
        "warning"
      );
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const updated = tickets.map((ticket) =>
        ticket.ticketNumber === ticketNumber
          ? { ...ticket, omcUploadedProofImage: reader.result, imageFile: file }
          : ticket
      );
      setTickets(updated);
      setPreviewImageBase64(reader.result);
      setShowPreviewModal(true);
    };
    reader.readAsDataURL(file);
  };




  const handleSave = async (ticket) => {
    try {
      const role = sessionStorage.getItem("role");
      const userId = sessionStorage.getItem("pkUserId");

      const response = await updateTicket(
        ticket.ticketNumber,
        ticket,
        { role, userId }
      );

      const result = response.data;

      if (result.message === "Ticket updated successfully") {
        const updated = tickets.map((t) =>
          t.ticketNumber === ticket.ticketNumber
            ? { ...t, isEditing: false, imageFile: null }
            : t
        );
        setTickets(updated);
        swal("Success", result.message, "success");
      } else {
        swal("Error", result.message || "Could not update ticket", "error");
      }

    } catch (error) {
      console.error("Failed to update ticket:", error);
      const errMsg = error.response?.data?.message || "Could not update ticket";
      swal("Error", errMsg, "error");
    }
  };



const filteredTickets = tickets.filter((ticket) =>
  ticket.ticketNumber
    ?.toString()
    .toLowerCase()
    .includes(searchTicketNo.toLowerCase())
);

// Pagination after filter
const indexOfLast = currentPage * rowsPerPage;
const indexOfFirst = indexOfLast - rowsPerPage;
const currentTickets = filteredTickets.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(filteredTickets.length / rowsPerPage);


  // const indexOfLast = currentPage * rowsPerPage;
  // const indexOfFirst = indexOfLast - rowsPerPage;
  // const currentTickets = tickets.slice(indexOfFirst, indexOfLast);
  // const totalPages = Math.ceil(tickets.length / rowsPerPage);

  const getFormLink = (jobType) => {
    if (!jobType || jobType.toLowerCase() === "unassigned") return null;

    switch (jobType.toLowerCase()) {
      case "installation":
        return "/Work-Orderx/installation";
      case "calibration":
        return "/Work-Orderx/calibration";
      case "field job":
        return "/Work-Orderx/field-job";
      default:
        return null;
    }
  };

  const getPriorityStyle = (priority) => {
    let backgroundColor = "gray";
    if (priority === "HIGH") backgroundColor = "red";
    else if (priority === "MEDIUM") backgroundColor = "orange";
    else if (priority === "LOW") backgroundColor = "green";

    return {
      fontWeight: "bold",
      color: "white",
      backgroundColor,
      textAlign: "center",
    };
  };

  return (
    <Container className="mt-4">
      <h5 className="mb-3">Omc Approved</h5>
        <Form.Control
    type="text"
    placeholder="Search by Ticket Number"
    value={searchTicketNo}
    onChange={(e) => {
      setSearchTicketNo(e.target.value);
      setCurrentPage(1);
    }}
    style={{ maxWidth: "250px" , }}
  />
      <div className="d-flex justify-content-end mb-2">

</div>

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover responsive style={{ backgroundColor: "white" }}>
          <thead className="header-class">
            <tr>
              <th>Ticket No.</th>
              <th>Ticket Type</th>
              <th>Ticket Status</th>
              {/* {role === "tech person" || role === "admin" ?
                <th>Generate WO</th> : <th></th>} */}

              <th>Ticket Priority</th>
              {/* <th>Action</th> */}
              <th>Issue Reported</th>
              <th>Remark by Nontech</th>
              <th>WO Status</th>
              <th>Dispenser Sr No</th>
              <th>OMC Approval</th>
              <th>WO approval OMC Proof</th>
              <th>RO Name</th>
              <th>Ro Contact</th>
              <th>Ro State</th>
              <th>RO City</th>
              <th>Ro District</th>
              <th>Ro Address</th>
              <th>Created At</th>




            </tr>
          </thead>
          <tbody>
            {currentTickets.map((ticket) => {
              console.log("TICKET ROW:", ticket);
              const isEditing = ticket.isEditing;
              const formLink = getFormLink(ticket.jobType);

              return (
                <tr key={ticket.ticketNumber}>
                  <td>{ticket.ticketNumber}</td>
                  {/* <td>{ticket.ticketType}</td> */}

                  {isEditing ? (
                    <>

                      <td>
                        <Form.Select
                          value={ticket.ticketType}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "ticketType", e.target.value)
                          }
                        >
                          <option value="NON_SLA">NON SLA</option>
                          <option value="SLA ">SLA </option>

                        </Form.Select>
                      </td>

                      <td>
                        <Form.Select
                          value={ticket.status}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "status", e.target.value)
                          }
                        >
                          <option value="OPEN">OPEN</option>
                          <option value="IN_PROGRESS">IN_PROGRESS</option>
                          <option value="CLOSE">CLOSE</option>
                        </Form.Select>
                      </td>
                      {/* {role === "tech person" || role === "admin" ?
                        <td>
                          {formLink ? (
                            <Link to={formLink} state={{ ticket }}>
                              <Button size="sm">Create WO </Button>
                            </Link>
                          ) : (
                            "-"
                          )}
                        </td>
                        : <td></td>
                      } */}
                      {/* <td>
                        <Form.Control
                          value={ticket.priority || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "priority", e.target.value)}
                        />
                      </td> */}
                      <td>
                        <Form.Select
                          value={ticket.priority || ""}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "priority", e.target.value)
                          }
                        >
                          <option value="HIGH">HIGH</option>
                          <option value="MEDIUM">MEDIUM</option>
                          <option value="LOW">LOW</option>
                        </Form.Select>
                      </td>
                      <td>
                        <Button size="sm" variant="success" onClick={() => handleSave(ticket)}>
                          Save
                        </Button>{" "}
                        <Button size="sm" variant="secondary" onClick={() => handleEditToggle(ticket.ticketNumber)}>
                          Cancel
                        </Button>
                      </td>

                       <td>
                        <Form.Control
                          value={ticket.issueReported || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "issueReported", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          value={ticket.remarkByNonTech || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "remarkByNonTech", e.target.value)}
                        />
                      </td>

                      <td>
                        <Form.Control
                          value={ticket.woStatus || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "woStatus", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          value={ticket.dispenserSrNo || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "dispenserSrNo", e.target.value)}
                        />
                      </td>
                      {/* <td>
                        <Form.Control
                          value={ticket.omcApprovalStatus || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "omcApprovalStatus", e.target.value)}
                        />
                      </td> */}

                      <td>
                        <Form.Select
                          value={ticket.omcApprovalStatus || ""}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "omcApprovalStatus", e.target.value)
                          }
                        >
                          <option value="PENDING">PENDING</option>
                          <option value="APPROVED">APPROVED</option>
                          <option value="NOT_REQUIRED ">NOT_REQUIRED  </option>
                        </Form.Select>
                      </td>
                      <td>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          onChange={(e) => handleFileChange(ticket.ticketNumber, e.target.files[0])}
                        />
                      </td>
                     

                      <td>
                        <Form.Control
                          value={ticket.roName || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roName", e.target.value)}
                        />
                      </td>

                      <td>
                        <Form.Control
                          value={ticket.roContact || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roContact", e.target.value)}
                        />
                      </td>

                      <td>
                        <Form.Control
                          value={ticket.roState || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roState", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          value={ticket.roCity || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roCity", e.target.value)}
                        />
                      </td>

                       <td>
                        <Form.Control
                          value={ticket.roDistrict || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roDistrict", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          value={ticket.roAddress || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "roAddress", e.target.value)}
                        />
                      </td>
                      <td>{moment(ticket.createdAt).format("DD MMM YYYY, h:mm A")}</td>



                    </>
                  ) : (
                    <>


                      <td>{ticket.ticketType}</td>

                      <td>
                        <span
                          style={{
                            padding: "5px 10px",
                            borderRadius: "5px",
                            color: "white",
                            backgroundColor:
                              ticket.status === "OPEN"
                                ? "red"
                                : ticket.status === "IN_PROGRESS"
                                  ? "orange"
                                  : "green",
                            fontWeight: "bold",
                          }}
                        >
                          {ticket.status}
                        </span>
                      </td>




                      <td style={getPriorityStyle(ticket.priority)}>{ticket.priority || "N/A"}</td>
                      {/* <td>
                        <Button size="sm" variant="primary" onClick={() => handleEditToggle(ticket.ticketNumber)}>
                          Update
                        </Button>
                      </td> */}
                        <td>{ticket.issueReported}</td>
                      <td>{ticket.remarkByNonTech || "N/A"}</td>
                      <td>{ticket.woStatus}</td>
                      <td>{ticket.dispenserSrNo}</td>
                      <td>{ticket.omcApprovalStatus}</td>
                      <td>
                        {ticket.omcUploadedProofImage ? (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              setPreviewImageBase64(ticket.omcUploadedProofImage);
                              setShowPreviewModal(true);
                            }}
                          >
                            View Image
                          </Button>
                        ) : (
                          " Image not uploaded"
                        )}
                      </td>
                      <td>{ticket.roName}</td>
                      <td>{ticket.roContact}</td>
                      <td>{ticket.roState}</td>
                      <td>{ticket.roCity}</td>
                      <td>{ticket.roDistrict}</td>
                      {/* <td>{ticket.roAddress}</td> */}
                        <td>{renderTableTooltip(ticket.roAddress)}</td>
                      <td>{moment(ticket.createdAt).format("DD MMM YYYY, h:mm A")}</td>








                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>

        {filteredTickets.length > rowsPerPage && (
          <div className="d-flex justify-content-center align-items-center my-3">
            <Button size="sm" variant="secondary" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
              Prev
            </Button>
            <span className="mx-3">
              Page {currentPage} of {totalPages}
            </span>
            <Button size="sm" variant="secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
              Next
            </Button>
          </div>
        )}
      </div>

      <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Uploaded Image </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImageBase64 ? (
            <img src={previewImageBase64} alt="Preview" style={{ maxWidth: "60%", height: "50%" }} />
          ) : (
            <p>No Image to display</p>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default OmcApproved;


